import { useSuspenseQuery } from '@tanstack/react-query'

import { regionPromotionsQuery } from './promotions'

export const useRegionPromotionList = (params: { regionId: string; initiativeId: string }) => {
  const { data: state } = useSuspenseQuery(regionPromotionsQuery(params))
  return state
}
